<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <h1 class="my-3 fw-bold titulo text-decoration-underline">REPORTE DE VENTA DIARIA</h1>
        </div>
    </div>
    <div class="row bg-white bordertop borderbott shadow pb-4">
        <div class="col-12 bgtable py-1 mb-3 d-flex bordertop">
            <span class="material-symbols-outlined">
                content_paste_search
            </span>
            <span class="fw-bold">
                Filtros
            </span> 
        </div>
        <div class="col-12 mt-2 pt-1 col-md-4 col-xl-3  d-flex justify-content-center" *ngIf="boolGerente">
            <mat-form-field appearance="outline" class="bg-white rounded w-100">
              <mat-label class="fw-bold py-0 my-0"><mat-icon>date_range</mat-icon>Gerente</mat-label>
              <mat-select [(ngModel)]="strGerente" class="" >
                <mat-option   value=""> --Todos --</mat-option> 
               <mat-option *ngFor="let x of arrayGerentes" [value]="x.strGerente">{{x.strNombre}}</mat-option> 
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 mt-2 pt-1 col-md-4  d-flex justify-content-center" [ngClass]="{'col-xl-2':boolGerente,'col-xl-3':boolSucursal && !boolGerente}" *ngIf="boolSucursal">
            <mat-form-field appearance="outline" class="bg-white rounded w-100">
              <mat-label class="fw-bold py-0 my-0"><mat-icon>date_range</mat-icon>Sucursal</mat-label>
              <mat-select [(ngModel)]="strSucursal" class="" >
                <mat-option value=""> --Todas --</mat-option> 
               <mat-option *ngFor="let x of arraySucursales | sucursalFilter:strGerente " [value]="x.strSucursal">{{x.strNombreSucursal}}</mat-option> 
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 mt-2 pt-1 col-md-4  d-flex justify-content-center" [ngClass]="{'col-xl-3':boolGerente||boolSucursal}" *ngIf="boolAgente">
            <mat-form-field appearance="outline" class="bg-white rounded w-100">
              <mat-label class="fw-bold py-0 my-0"><mat-icon>date_range</mat-icon>Agente</mat-label>
              <mat-select [(ngModel)]="strAgente" class="" >
                <mat-option value=""> --Todos --</mat-option> 
               <mat-option *ngFor="let x of arrayAgentes |agenteFilter:strGerente:strSucursal" [value]="x.strAgente">{{x.strNombre}}</mat-option> 
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 mt-2 pt-1 col-md-4  d-flex justify-content-center" [ngClass]="{'col-xl-2':boolGerente,'col-xl-3':boolSucursal && !boolGerente}">
            <mat-form-field appearance="outline" class="bg-white rounded w-100">
              <mat-label class="fw-bold py-0 my-0"><mat-icon>date_range</mat-icon>Periodo</mat-label>
              <mat-select [(ngModel)]="intPeriodo" class="" >
               <mat-option *ngFor="let x of arrayPeriodo" [value]="x.strPeriodo">{{x.strNombre}}</mat-option> 
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 mt-2 pt-1 col-md-4   d-flex justify-content-center"[ngClass]="{'col-xl-1':boolGerente,'col-xl-2':boolSucursal && !boolGerente,'col-xl-3':boolAgente &&!boolSucursal && !boolGerente }" >
            <mat-form-field appearance="outline" class="bg-white rounded w-100">
                <mat-label class="fw-bold"><mat-icon>event_note</mat-icon>Ejercicio</mat-label>
                <mat-select [(ngModel)]="intEjercicio">
                    <mat-option *ngFor="let e of arrayEjercicio" [value]="e.ejercicio">
                        {{e.ejercicio}}
                    </mat-option> 
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 mt-2 pt-1  col-md-4  d-flex justify-content-center align-items-center" [ngClass]="{'col-xl-1':boolGerente ||boolSucursal||boolAgente  }" >
            <button class="btn btnFilter shadow-sm px-2 py-1" (click)="fnGetVentasDiarias()" (mouseenter)="isHoveredButton = true" (mouseleave)="isHoveredButton = false">
                <i class="bi  p-1 fs-4"  [ngClass]="{'bi-filter': !isHoveredButton, 'bi-filter-circle-fill': isHoveredButton}"></i>
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-12 my-3 px-0 shadow bordertop borderbott clsIcon">
            <div class="col-12 d-flex justify-content-evenly">
                <mat-form-field appearance="outline" class="my-2  rounded bg-white text-dark">
                    <mat-label>Buscar</mat-label>
                    <input matInput (keyup)="applyFilterTareasCte($event)" placeholder="ID,Tarea,etc..." #input>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" class="my-2  rounded bg-white text-dark">
                    <mat-label>Dias</mat-label>
                    <mat-select [(ngModel)]="Intdia"  (selectionChange)="fnFiltrarDias()">
                        <mat-option  value="">--TODOS--</mat-option>
                      <mat-option *ngFor="let dia of arrayDias" [value]="dia">{{dia}}</mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>

            <div class="mb-0 table-responsive ">
                <div class="mat-elevation-z8 mb-0  shadow">
                    <table mat-table [dataSource]="datosTareasCte" class="table table-hover"  matSort #sortTareasCte="matSort">
                         <!-- fechaemision Column -->
                      <ng-container matColumnDef="fechaemision">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="ps-0 fs13 nunito fw-bold clsIcon">FECHA EMISION</th>
                        <td mat-cell *matCellDef="let row" class="px-2 fs11 text-center align-middle fw-bold"> 
                        {{convertirFecha(row.strFechaEmision)|date:'dd/MM/yyyy'}}
                        </td>
                      </ng-container>
                      <!-- sucursal Column -->
                      <ng-container matColumnDef="sucursal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="ps-0 fs13 nunito fw-bold clsIcon"> SUCURSAL </th>
                        <td mat-cell *matCellDef="let row" class="mostDet fw-bold ps-0 fs13 text-center align-middle"> 
                          <span>
                            <span class="fw-bold">({{row.strSucursal}})</span>
                            {{row.strNombreSucursal}}
                          </span>  
                        </td>
                      </ng-container>
                      <!-- dia Column -->
                      <ng-container matColumnDef="dia">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs13 nunito fw-bold clsIcon"> DIA </th>
                        <td mat-cell *matCellDef="let row" class="fs11 text-center align-middle fw-bold"> {{row.intDia}} </td>
                      </ng-container>
                      <!-- importe Column -->
                      <ng-container matColumnDef="importe">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header  class="fs13 nunito fw-bold clsIcon"> IMPORTE </th>
                        <td mat-cell *matCellDef="let row;let ind=index" class="fs12 text-end align-middle">
                           {{row.dblImporteT|currency}}
                        </td>
                      </ng-container>
                
                      <tr mat-header-row class="rounded" class="sticky-top" *matHeaderRowDef="columnsTareasCte"></tr>
                      <tr mat-row *matRowDef="let row; columns: columnsTareasCte;" ></tr>
                  
                     
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6">No se encontraron datos de: "{{input.value}}"</td>
                      </tr>
                    </table>
                  </div>
            </div>
            <mat-paginator class="paginator borderbott" [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of users" #paginadorTareasCte></mat-paginator>
        </div>
    </div>

    
</div>




